import React, { Component, createRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faTimes } from '@fortawesome/free-solid-svg-icons';

class Typeahead extends Component {

    constructor(props) {
        super(props);
        this.state = {
            options: props.options,
            value: props.value,
            show: false,
        };
        this.input = createRef();
        this.onChange = this.onChange.bind(this);
        this.onClickOption = this.onClickOption.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ options: nextProps.options });
    }

    onChange(e) {
        let search = e.currentTarget.value;
        this.setState({ value: search });
        let options = this.props.options.reduce((memo, option) => {
            if (option.toLowerCase().includes(search.trim().toLowerCase())) {
                memo.push(option);
            }
            return memo;
        }, []);
        this.setState({ options });
    }

    onClickOption(e) {
        this.setState({
            show: false,
            value: e.target.dataset.value,
            options: this.props.options,
        }, _ => this.props.onChange(this.input.current));
    }

    render() {
        let options = this.state.options.map(option =>
            <li className='dropdown-item small text-truncate py-0 px-2'
                key={option}
                data-value={option}
                title={option}
                style={{ cursor: 'pointer' }}>
                {option}
            </li>
        );

        return (
            <>
                {
                    this.props.label ?
                        <label className='text-nowrap small m-0'>{this.props.label}</label> : null
                }
                <input className='form-control form-control-sm rounded-0 bg-transparent text-light text-truncate pl-0 pr-3'
                    ref={this.input}
                    id={this.props.label + '-dropdownMenu'}
                    name={this.props.name}
                    role='button'
                    aria-haspopup={true}
                    aria-expanded={this.state.show}
                    type='text'
                    placeholder={this.props.label}
                    title={this.state.value}
                    value={this.state.value}
                    autoComplete='off'
                    onChange={this.onChange}
                    onFocus={_ => setTimeout(_ => this.setState({ show: true }), 200)}
                    onBlur={_ => setTimeout(_ => this.setState({ show: false }), 200)}
                />
                <span className='position-absolute'
                    style={{ right: '1.2rem', bottom: '0.2rem', cursor: 'pointer' }}>
                    {
                        this.state.value === '' ?
                            <i onClick={event => { event.currentTarget.parentNode.previousSibling.focus() }}>
                                <FontAwesomeIcon icon={faCaretDown} /></i> :
                            <i onClick={_ => {
                                this.setState({
                                    value: ''
                                }, _ => this.props.onChange(this.input.current));
                            }}><FontAwesomeIcon icon={faTimes} /></i>
                    }
                </span>
                <ul className={'dropdown-menu m-0 p-0 rounded-0' + (this.state.show ? ' show' : '')}
                    aria-labelledby={this.props.label + '-dropdownMenu'}
                    onClick={this.onClickOption}
                    style={{ maxHeight: '12rem', minWidth: 'calc(100% - 2rem)', left: '1rem', right: '1rem', overflowY: 'auto' }}>
                    {options}
                </ul>
            </>
        );
    }
}

export default Typeahead;